import { useTranslation } from "react-i18next";
import JsonLd from "@/components/base/JsonLd";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://wyzon.io";

const webPageSchemaTerms = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Terms of Service - Wyzon",
  "url": `${siteUrl}/terms`,
  "description": "Wyzon terms of service outlining the rules, guidelines, and legal agreements for using our WhatsApp automation and customer messaging platform.",
};

export default function Terms() {
  const { t } = useTranslation("terms");

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={webPageSchemaTerms} />
      <div className="max-w-3xl mx-auto px-4 md:px-6 lg:px-8 py-16 md:py-24 lg:py-32">
        <div className="mb-12 md:mb-16">
          <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 mb-3">
            {t("terms.title")}
          </h1>
          <p className="text-foreground-500 text-sm">{t("terms.lastUpdated")}</p>
        </div>

        <div className="prose-custom space-y-10">
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed">
            {t("terms.intro")}
          </p>

          {[1, 2, 3, 4, 5, 6, 7, 8].map((n) => (
            <section key={n}>
              <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4">
                {t(`terms.section${n}.title`)}
              </h2>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                {t(`terms.section${n}.content`)}
              </p>
            </section>
          ))}

          <div className="mt-12 pt-10 border-t border-background-200">
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
              {t("terms.contact")}
            </p>
            <div className="space-y-2">
              <a
                href="mailto:sales@debugin.com"
                className="text-primary-600 hover:text-primary-700 text-sm md:text-base underline underline-offset-4 transition-colors"
              >
                sales@debugin.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}